export type WasteCatagoryType =
  | "graffiti_posters_and_stickers"
  | "dumped_rubbish"
  | "bin_bags"
  | "cardboard_boxes"
  | "litter"
  | "dead_animals"
  | "bins"
  | "dog_poo"
  | "street_cleaning"
  | "";

const validWasteCategories = [
  "graffiti_posters_and_stickers",
  "dumped_rubbish",
  "bin_bags",
  "cardboard_boxes",
  "litter",
  "dead_animals",
  "bins",
  "dog_poo",
  "street_cleaning",
];

// Routes that require a valid waste category to be present
const validRoutes = [
  "/waste/upload-photo",
  "/waste/waste-details",
  "/waste/your-details",
  "/waste/confirmation",
  "waste/404",
  "/callbacks",
];

export const isValidWasteCategoryAndRoute = (
  category: WasteCatagoryType,
  path: string,
) => {
  // If the check isn't part of the routes that require a valid waste category, return true
  if (!validRoutes.includes(path)) {
    return true;
  }
  return validWasteCategories.includes(category) && validRoutes.includes(path);
};
